export default {
  title: 'digital-textbook',
  version: '0.1'
}